import React from 'react';
import PropTypes from 'prop-types';

import { Heading } from 'components/common/Elements/Elements';

import classes from './NetworkBodySetting.module.scss';

const NetworkBodySetting = ({ selectId }) => {
  return (
    <div className={classes.bodyNetworkWraper}>
      <Heading>{selectId}</Heading>
    </div>
  );
};

NetworkBodySetting.propTypes = {
  selectId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default NetworkBodySetting;
